exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nbody {\n  -webkit-user-select : none;\n     -moz-user-select : none;\n      -ms-user-select : none;\n          user-select : none;\n  margin      : 0 auto;\n  font-family : \"Avenir\", \"PingFang SC\";\n}\n", "", {"version":3,"sources":["/Users/zhangpuxi/ZhangPuXi/Workspace/WebGaotieVue/src/projects/virusTrip/pages/home/index.vue"],"names":[],"mappings":";AACA;EACE,2BAA2B;KACxB,wBAAwB;MACvB,uBAAuB;UACnB,mBAAmB;EAC3B,qBAAqB;EACrB,sCAAsC;CACvC","file":"index.vue","sourcesContent":["\nbody {\n  -webkit-user-select : none;\n     -moz-user-select : none;\n      -ms-user-select : none;\n          user-select : none;\n  margin      : 0 auto;\n  font-family : \"Avenir\", \"PingFang SC\";\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f4167044","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/projects/virusTrip/pages/home/index.vue
// module id = LXtT
// module chunks = 1